<template>
  <div>
    <el-table
      :data="rows"
      @sort-change="doChangeSort"
      ref="table"
      row-key="id"
      v-loading="loading"
    >

      <!-- Name -->
      <el-table-column
        :label="fields.name.label" 
        :prop="fields.name.name" 
        min-width="120"
      >
        <template slot-scope="scope">
          <el-tooltip
            :disabled="!hasPermissionToAuditLogs"
            effect="dark"
            :content="scope.row.id"
            placement="bottom"
          >
            <span
              v-text="presenter(scope.row, 'name')"
            />
          </el-tooltip>
        </template>
      </el-table-column>

      <el-table-column
        :label="fields.createdAt.label"
        :prop="fields.createdAt.name"
        
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'createdAt') }}</template>
      </el-table-column>

      <el-table-column :fixed="isMobile? undefined : 'right'" align="center" width="180">
        <template slot-scope="scope">
          <div class="table-actions">
            <router-link :to="`/subproperty/settings/program/location/${scope.row.id}/edit`" v-if="hasPermissionToEdit">
              <el-button icon="icon-pen" circle />
            </router-link>

            <el-button
              v-if="hasPermissionToDestroy"
              :disabled="destroyLoading"
              @click="doDestroyWithConfirm(scope.row.id)"
              circle
              icon="icon-trash"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="el-pagination-wrapper">
      <el-pagination
        :current-page="pagination.currentPage || 1"
        :disabled="loading"
        :layout="paginationLayout"
        :total="count"
        @current-change="doChangePaginationCurrentPage"
        @size-change="doChangePaginationPageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { LocationModel } from '@modules/location/location-model';
import { mapGetters, mapActions } from 'vuex';
import { LocationPermissions } from '@modules/location/location-permissions';
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { i18n } from '@shared/i18n';

const { fields } = LocationModel;

export default {
  name: 'app-location-list-table',

  mounted() {
    // this.doMountTable(this.$refs.table);
  },

  computed: {
    ...mapGetters({
      rows: 'location/list/rows',
      count: 'location/list/count',
      loading: 'location/list/loading',
      pagination: 'location/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'location/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new LocationPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new LocationPermissions(this.currentUser).destroy;
    },

    fields() {
      return fields;
    },

    isAdmin() {
      if (this.currentUser && this.currentUser.isAdmin) {
        return this.currentUser.isAdmin;
      }
      return false;
    },

    // isDisabledRemove(){
    //   const isDisabledForNormalUsers = process.env.VUE_APP_DISABLE_REMOVE_BUTTON_LOCATION_NORMAL_USERS === 'true' && !this.isAdmin;
    //   return isDisabledForNormalUsers;
    // }
  },

  methods: {
    ...mapActions({
      doChangeSort: 'location/list/doChangeSort',
      doChangePaginationCurrentPage:
        'location/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'location/list/doChangePaginationPageSize',
      doMountTable: 'location/list/doMountTable',
      doDestroy: 'location/destroy/doDestroy',
    }),

    presenter(row, fieldName) {
      return LocationModel.presenter(row, fieldName);
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy(id);
      } catch (error) {
        // no
      }
    },
  },
};
</script>

<style>
</style>
